import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';


@Injectable()
export class ProductSegmentService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    delete(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productSegments.delete.api;
        return this.requestService.post(url, details);
    }
    add(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productSegments.add.api;
        return this.requestService.post(url, details);
    }
    edit(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productSegments.edit.api;
        return this.requestService.post(url, details);
    }
    getProductSegmentDetails(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productSegments.details.api + '/' + id;
        return this.requestService.get(url);
    }

    formatData(details: any) {
        const obj = {
            customerSegments: details.customerSegments ? details.customerSegments.map(_ => {return { id: _ }}) : []
        }
        let result = Object.assign({}, details);
        result = Object.assign(result, obj);
        return result;
    }

    getDetailsFields() {
        const fields = [
            {
                key: 'code',
                label: 'Code',
                type: 'text'
            }, {
                key: 'name',
                label: 'Name',
                type: 'text'
            }, {
                id: 'examInformation',
                key: 'examInformation',
                label: 'Exam Information',
                type: 'html'
            }, {
                id: 'accreditationFee',
                key: 'accreditationFee',
                label: 'Accreditation Fee',
                type: 'html'
            }, {
                id: 'restrictionMessage',
                key: 'restrictionMessage',
                label: 'Restriction Message',
                type: 'html'
            }, {
                id: 'trainerRequirements',
                key: 'trainerRequirements',
                label: 'Trainer Requirements',
                type: 'html'
            }, {
                id: 'accreditationRequirements',
                key: 'accreditationRequirements',
                label: 'Accreditation Requirements',
                type: 'html'
            }, {
                id: 'sellerAccreditationStatus',
                key: 'sellerAccreditationStatus',
                label: 'Seller Accreditation Status',
                type: 'html'
            }, {
                id: 'accreditationProcess',
                key: 'accreditationProcess',
                label: 'Accreditation Process',
                type: 'html'
            }, {
                id: 'sellerRole',
                key: 'sellerRole',
                label: 'Seller Role',
                type: 'html'
            }, {
                id: 'atoSegment',
                key: 'atoSegment',
                label: 'ATO Segment',
                type: 'html'
            }, {
                key: (data: any) => {
                    let result = [];
                    if(data.customerSegments && data.customerSegments.length) data.customerSegments.forEach(element => {
                        result.push(element.configValue);
                    });
                    return result;
                },
                label: 'Customer Segments',
                type: 'list'
            }
        ];
        return fields;
    };

    getFields() {
        let fields = [
            {
                key: 'id',
                label: 'ID',
                type: 'hidden',
                required: false
            }, {
                key: 'code',
                label: 'Code',
                type: 'textbox',
                required: true
            }, {
                key: 'name',
                label: 'Name',
                type: 'textbox',
                required: true
            }, {
                key: 'examInformation',
                label: 'Exam Information',
                type: 'html-editor'
            }, {
                key: 'accreditationFee',
                label: 'Accreditation Fee',
                type: 'html-editor'
            }, {
                key: 'restrictionMessage',
                label: 'Restriction Message',
                type: 'html-editor'
            }, {
                key: 'trainerRequirements',
                label: 'Trainer Requirements',
                type: 'html-editor'
            }, {
                key: 'accreditationRequirements',
                label: 'Accreditation Requirements',
                type: 'html-editor'
            }, {
                key: 'sellerAccreditationStatus',
                label: 'Seller Accreditation Status',
                type: 'html-editor'
            }, {
                key: 'accreditationProcess',
                label: 'Accreditation Process',
                type: 'html-editor'
            }, {
                key: 'sellerRole',
                label: 'Seller Role',
                type: 'html-editor'
            }, {
                key: 'atoSegment',
                label: 'ATO Segment',
                type: 'html-editor'
            }, {
                key: 'customerSegments',
                label: 'Customer Segments',
                type: 'multi-dropdown',
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.accountAccreditationsProducts.api
            }
        ];
        return fields;
    };

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-segments/product-segment.service.ts